export default ({ theme }) => ({
    '> button': {
        padding: '3px 0',
    },
    '> button > svg': {
        fill: theme.colors.text,
        verticalAlign: 'middle',
    },
});
